import ScrollReveal from '@/components/feature/ScrollReveal';
import StarRating from '@/components/feature/StarRating';
import { sanitizeText } from '@/utils/sanitize';

const testimonials = [
  {
    text: "Lucky Holidays made our honeymoon absolutely magical! Every detail was perfectly planned — from the scenic train rides to the luxury hotel with breathtaking Alpine views. Chethan and team truly understand what makes a trip special.",
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20happy%20young%20Indian%20couple%20in%20their%20late%2020s%2C%20the%20woman%20with%20long%20dark%20hair%20wearing%20a%20maroon%20kurta%2C%20the%20man%20in%20a%20navy%20blue%20shirt%2C%20both%20smiling%20warmly%20at%20the%20camera%2C%20clean%20soft%20white%20studio%20background%20with%20subtle%20warm%20lighting%2C%20editorial%20portrait%20photography%2C%20high%20quality%2C%20natural%20expressions%2C%20head%20and%20shoulders%20composition&width=200&height=200&seq=review-avatar-priya&orientation=squarish',
    name: 'Priya & Arjun Sharma',
    trip: 'Switzerland Honeymoon',
    rating: 5,
  },
  {
    text: "Took my family of 6 to Dubai and everything was flawlessly organized. The hotel was spectacular, desert safari was thrilling, and the kids loved every moment. Lucky Holidays is now our go-to for all family vacations.",
    image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20an%20Indian%20man%20in%20his%20mid%2040s%2C%20salt%20and%20pepper%20short%20hair%2C%20wearing%20a%20light%20blue%20formal%20shirt%2C%20friendly%20confident%20smile%2C%20warm%20brown%20skin%20tone%2C%20clean%20white%20studio%20background%2C%20soft%20diffused%20lighting%2C%20editorial%20style%20photography%2C%20head%20and%20shoulders%20shot%2C%20natural%20expression&width=200&height=200&seq=review-avatar-rajesh&orientation=squarish',
    name: 'Rajesh Kumar',
    trip: 'Dubai Family Trip',
    rating: 5,
  },
  {
    text: "Our overwater villa experience in Maldives was beyond words. Lucky Holidays handled everything — flights, resort, seaplane transfers, even surprise candlelight dinner. Pure luxury from start to finish.",
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20stylish%20young%20Indian%20couple%20in%20their%20early%2030s%2C%20the%20woman%20with%20shoulder%20length%20wavy%20dark%20hair%20wearing%20an%20elegant%20cream%20silk%20top%2C%20the%20man%20with%20a%20trimmed%20beard%20wearing%20a%20crisp%20white%20shirt%2C%20both%20with%20genuine%20joyful%20smiles%2C%20clean%20soft%20beige%20studio%20background%2C%20warm%20natural%20lighting%2C%20editorial%20portrait%20photography%2C%20head%20and%20shoulders%20composition&width=200&height=200&seq=review-avatar-meera&orientation=squarish',
    name: 'Meera & Vikram',
    trip: 'Maldives Luxury Escape',
    rating: 5,
  },
  {
    text: "Organized a corporate group of 25 to Europe. The logistics were complex but Lucky Holidays executed it perfectly. Flawless coordination, excellent hotels, knowledgeable guides. Highly recommended for corporate travel.",
    image: 'https://readdy.ai/api/search-image?query=Professional%20business%20headshot%20of%20an%20Indian%20man%20in%20his%20late%2030s%2C%20clean%20shaven%20with%20neatly%20styled%20short%20black%20hair%2C%20wearing%20a%20sharp%20charcoal%20grey%20blazer%20over%20a%20white%20shirt%2C%20confident%20professional%20smile%2C%20warm%20olive%20skin%20tone%2C%20clean%20light%20grey%20studio%20background%2C%20soft%20diffused%20corporate%20lighting%2C%20editorial%20portrait%20photography%2C%20head%20and%20shoulders%20composition&width=200&height=200&seq=review-avatar-anand&orientation=squarish',
    name: 'Anand Srinivasan',
    trip: 'Europe Group Tour',
    rating: 5,
  },
  {
    text: "Our Kerala backwaters trip was exceptional! The houseboat was pristine, the itinerary perfectly paced for our elderly parents, and the local experiences were authentic. Thank you Lucky Holidays for creating such beautiful memories.",
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20Indian%20woman%20in%20her%20mid%2030s%2C%20long%20dark%20silky%20hair%2C%20wearing%20a%20beautiful%20green%20silk%20saree%20with%20gold%20border%2C%20warm%20genuine%20smile%2C%20glowing%20skin%20with%20subtle%20makeup%2C%20clean%20soft%20white%20studio%20background%2C%20elegant%20natural%20lighting%2C%20editorial%20portrait%20photography%2C%20head%20and%20shoulders%20composition%2C%20graceful%20expression&width=200&height=200&seq=review-avatar-deepa&orientation=squarish',
    name: 'Deepa Menon',
    trip: 'Kerala Family Holiday',
    rating: 5,
  },
  {
    text: "Bali was incredible! Private pool villa, sunset temple visits, and the most romantic dinner setup we have ever experienced. Lucky Holidays pays attention to the smallest details that make a trip truly special.",
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Indian%20couple%20in%20their%20late%2020s%2C%20the%20woman%20with%20curly%20dark%20hair%20wearing%20a%20coral%20pink%20top%2C%20the%20man%20with%20short%20styled%20hair%20wearing%20a%20light%20grey%20linen%20shirt%2C%20both%20with%20bright%20happy%20smiles%2C%20clean%20soft%20cream%20studio%20background%2C%20warm%20diffused%20lighting%2C%20editorial%20portrait%20photography%2C%20head%20and%20shoulders%20composition%2C%20romantic%20couple%20vibes&width=200&height=200&seq=review-avatar-suresh&orientation=squarish',
    name: 'Suresh & Kavya',
    trip: 'Bali Romantic Getaway',
    rating: 5,
  },
];

const aggregateSchema = {
  '@context': 'https://schema.org',
  '@type': 'AggregateRating',
  itemReviewed: {
    '@type': 'TravelAgency',
    name: 'Lucky Holidays India Private Limited',
    image: 'https://www.luckyholidays.in/lucky-holidays-logo.webp',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Pandian Street, Chinna Thirupathi, Salem',
      addressLocality: 'Hosur',
      addressRegion: 'Tamil Nadu',
      postalCode: '635109',
      addressCountry: 'IN',
    },
    telephone: '+91-90035-60700',
    url: 'https://www.luckyholidays.in/',
  },
  ratingValue: '5',
  bestRating: '5',
  reviewCount: '5000',
};

export default function ReviewsSection() {
  return (
    <section id="reviews" className="py-16 md:py-24 bg-background-50">
      <script type="application/ld+json">{JSON.stringify(aggregateSchema)}</script>
      {testimonials.map((t, idx) => (
        <script key={idx} type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Review',
            author: { '@type': 'Person', name: t.name },
            reviewRating: { '@type': 'Rating', ratingValue: String(t.rating), bestRating: '5' },
            reviewBody: t.text,
            itemReviewed: {
              '@type': 'TravelAgency',
              name: 'Lucky Holidays India Private Limited',
            },
          })}
        </script>
      ))}
      <div className="w-full px-4 md:px-8 lg:px-16 3xl:max-w-[1800px] 3xl:mx-auto tv:max-w-[3000px] tv:mx-auto">
        <ScrollReveal>
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-4 py-1.5 bg-accent-50 text-accent-700 text-xs font-semibold tracking-widest uppercase rounded-full mb-4">
              Testimonials
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl 3xl:text-6xl font-bold text-foreground-900 mb-4">
              {'What Our Travelers Say'.split(' ').map((word, i) => (
                <span
                  key={i}
                  className="inline-block mr-[0.3em] animate-text-reveal"
                  style={{ animationDelay: `${i * 0.1}s` }}
                >
                  {word}
                </span>
              ))}
            </h2>
            <div className="flex items-center justify-center gap-2 mt-2" itemScope itemType="https://schema.org/AggregateRating">
              <meta itemProp="ratingValue" content="5" />
              <meta itemProp="bestRating" content="5" />
              <meta itemProp="reviewCount" content="5000" />
              <span className="text-accent-500 text-sm font-semibold">5.0</span>
              <div className="flex">
                {[1, 2, 3, 4, 5].map(s => (
                  <i key={s} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <span className="text-foreground-600 text-xs">from 5,000+ happy travelers</span>
            </div>
            <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base leading-relaxed animate-text-reveal mt-3" style={{ animationDelay: '0.5s' }}>
              Real stories from real travelers who trusted us with their dream vacations across India and the world.
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 3xl:grid-cols-4 tv:grid-cols-5 gap-5 md:gap-6">
          {testimonials.map((t, idx) => (
            <ScrollReveal key={t.image + t.name} delay={idx * 80} direction="up" distance={30}>
              <div
                className="p-6 md:p-7 bg-background-50 border border-background-200/70 rounded-2xl hover:border-accent-200 transition-all duration-300 flex flex-col card-hover-lift"
                itemScope
                itemType="https://schema.org/Review"
              >
                <div className="mb-4" itemScope itemType="https://schema.org/Rating" itemProp="reviewRating">
                  <meta itemProp="ratingValue" content={String(t.rating)} />
                  <meta itemProp="bestRating" content="5" />
                  <StarRating total={5} delay={idx * 80} />
                </div>
                <p className="text-foreground-600 text-sm leading-relaxed flex-1 mb-5 italic testimonial-hover-text" itemProp="reviewBody">
                  &ldquo;{sanitizeText(t.text)}&rdquo;
                </p>
                <div className="flex items-center gap-3 pt-4 border-t border-background-200">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 group-hover-icon-bounce">
                    <img
                      src={t.image}
                      alt={`${sanitizeText(t.name)} - Lucky Holidays traveler review`}
                      title={`${sanitizeText(t.name)} - Lucky Holidays traveler review`}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <div className="font-heading text-sm font-semibold text-foreground-900" itemProp="author">{sanitizeText(t.name)}</div>
                    <div className="text-xs text-foreground-500">{sanitizeText(t.trip)}</div>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}